<template>
  <!-- 须知 -->
  <div class="mask" @click.self="closeNotice" v-show="stateNotice">
    <div class="notice" v-if="stageControl">
      <div class="header">
        <div class="left">
          <i class="icon icon-ticket2"></i
          ><span>{{ currentNotice.title }}</span>
        </div>
        <img class="right" src="~@/assets/image/common/common_logo.png" alt="">
      </div>
      <main>
        <greentitle titleText="购票须知" />
        <div class="temporary" v-html="currentNotice.description"></div>
        <!-- <div class="use">
            <div class="use-title">
              <span class="msg">使用说明</span
              ><span class="msg-dt">*仅限使用日期当天可用，过期无效</span>
            </div>
            <div class="use-type">
              <span>门票类型</span>
              <span>公园验票</span>
              <span>是否需要换票</span>
            </div>
            <ul>
              <li>
                <span>身份证票</span>
                <span>刷<em>身份证</em></span>
                <span>否</span>
              </li>
              <li>
                <span>身份证票</span>
                <span>刷<em>二维码凭证</em></span>
                <span>否</span>
              </li>
            </ul>
          </div>
          <div class="use use2">
            <div class="use-title">
              <span class="msg">退改说明</span
              ><span class="msg-dt">超出使用日期7天不可申请退票退款</span>
            </div>
            <div class="use-type">
              <span>申请退票时间</span>
              <span>是否可退</span>
              <span>退回金额</span>
              <span>退回时间</span>
            </div>
            <ul>
              <li>
                <span>使用日期前</span>
                <span>可退</span>
                <span>100%</span>
                <span>七个工作日内</span>
              </li>
              <li>
                <span>使用日期前</span>
                <span>可退</span>
                <span>100%</span>
                <span>七个工作日内</span>
              </li>
            </ul>
          </div> -->
      </main>
      <div class="payment">
        <div class="left">
          <span>门票价格</span><em>{{ currentNotice.price }}</em>
        </div>
        <div @click="scheduled" class="right">立即预订</div>
      </div>
    </div>
    <group-notice
    :currentItem="currentNotice"
    @closeStateNotice="closeStateNotice"
    :groupStateNotice="groupStateNotice"
    v-if="groupStateNotice">
    </group-notice>
  </div>
</template>

<script>
import groupNotice from "@/components/entry/ticketlist/group-notice/index.vue";
export default {
  name: "remind",
  props:['currentNotice', 'stateNotice', 'reserveUrl'],
  data(){
    return {
      currentItem: {},
      groupStateNotice: false,
      stageControl: true,
    }
  },
  methods: {
    closeNotice(){
      this.$emit('closeNotice', !this.stateNotice);
    },
    scheduled(){
      // if(this.reserveUrl === 'touristguideshoppingcart'){
      //   this.groupStateNotice = true;
      //   this.stageControl = false;
      //   return
      // }
      if(!this.reserveUrl)return this.$emit('closeNotice', !this.stateNotice);
      this.$beyondHiding(false);
      this.$router.push(`/${this.reserveUrl}?ticketcode=${this.currentNotice.code}`);
    },
    closeStateNotice(){
      this.stageControl = true;
      this.groupStateNotice = false;
      this.$beyondHiding(false);
      this.$emit('closeNotice', !this.stateNotice);
    },
  },
  watch: {
    stateNotice(newValue){
      this.$beyondHiding(newValue)
    }
  },
  components: {
    'group-notice': groupNotice,
  }
};
</script>

<style scoped lang='less'>
.mask {
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.42);
  z-index: 9;
}
.notice {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  .header {
    height: 0.813333rem * 2;
    background: #f1f2f7;
    border-radius: 0.32rem * 2 0.32rem * 2 0 0;
    padding: 0 0.4rem;
    font-size: 0.533333rem;
    color: #222328;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      i {
        width: 0.533333rem;
        height: 0.533333rem;
        margin-right: 0.16rem;
      }
    }
    .right {
      width: 0.88rem;
      height: 0.88rem;
    }
  }
  main {
    padding: 0.4rem 0.32rem;
    background: #fff;
    line-height: 1;
    .use {
      .use-title {
        margin: 0.213333rem 0;
        .msg {
          color: #a1a6ba;
          font-size: 0.373333rem;
          margin-right: 1.12rem;
        }
        .msg-dt {
          font-size: 0.32rem;
          color: #333333;
        }
      }
      .use-type {
        line-height: 0.906667rem;
        background: #e4e7f0;
        font-size: 0.373333rem;
        color: #333333;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        text-align: center;
        span {
          flex: 1;
          &:nth-child(2) {
            flex: 2;
          }
          &:last-child {
            padding-right: 0.32rem;
          }
        }
      }
      ul {
        color: #333333;
        li {
          font-size: 0.346667rem;
          line-height: 0.346667rem * 2;
          display: flex;
          justify-content: space-between;
          text-align: center;
          span {
            flex: 1;
            &:nth-child(2) {
              flex: 2;
            }
            em {
              color: #BF2424;
            }
          }
        }
      }
    }
    .use2 {
      margin-top: .346667rem * 2;
      .use-type {
        span {
          flex: 1;
          &:nth-child(2) {
            flex: 1;
          }
          &:first-child {
            padding-left: 0.32rem;
          }
          &:last-child{
            padding: 0;
          }
        }
      }
      ul {
        li {
          span {
            flex: 1;
            &:nth-child(2) {
              flex: 1;
            }
          }
        }
      }
    }
  }
  .payment{
    display: flex;
    line-height: 1.626667rem;
    text-align: center;
    font-size: .213333rem * 2;
    box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.16);
    .left{
      width: 2.96rem * 2;
      background: #fff;
      em{
        color: #BF2424;
        margin-left: .32rem;
        font-weight: bold;
      }
    }
    .right{
      flex: 1;
      background: #3B6D9C;
      color: #FFFFFF;
    }
  }
}


.temporary{
  height: 3.973333rem * 2;
  overflow-y: scroll;
  margin-top: .16rem * 2;
}
</style>
